import { ICustomProperty, IOperatorReplacement, IPromptMessages } from './index.d';


export const operatorsMap = [{
        code: 'is not',
        eatRegexp: /^is\s+not/i,
        matchRegexp: /^is\s+not($|\s+)/i,
        type: 'operator IS-NOT'
    },
    {
        code: 'is',
        eatRegexp: /^is/i,
        matchRegexp: /^is($|\s+)/i,
        type: 'operator IS'
    },
    {
        code: 'any is not',
        eatRegexp: /^any\s+is\s+not/i,
        matchRegexp: /^any\s+is\s+not($|\s+)/i,
        type: 'operator ANY-IS-NOT'
    },
    {
        code: 'any is',
        eatRegexp: /^any\s+is/i,
        matchRegexp: /^any\s+is($|\s+)/i,
        type: 'operator ANY-IS'
    },
    {
        code: 'all is not',
        eatRegexp: /^all\s+is\s+not/i,
        matchRegexp: /^all\s+is\s+not($|\s+)/i,
        type: 'operator ALL-IS-NOT'
    },
    {
        code: 'all is',
        eatRegexp: /^all\s+is/i,
        matchRegexp: /^all\s+is($|\s+)/i,
        type: 'operator ALL-IS'
    },
    {
        code: 'not contain',
        eatRegexp: /^not\s+contain/i,
        matchRegexp: /^not\s+contain($|\s+)/i,
        type: 'operator NOT-CONTAIN'
    },
    {
        code: 'contain',
        eatRegexp: /^contain/i,
        matchRegexp: /^contain($|\s+)/i,
        type: 'operator CONTAIN'
    },
    {
        code: 'not in',
        eatRegexp: /^not\s+in/i,
        matchRegexp: /^not\s+in($|\s+)/i,
        type: 'operator NOT-IN'
    },
    {
        code: 'in',
        eatRegexp: /^in/i,
        matchRegexp: /^in($|\s+)/i,
        type: 'operator IN'
    },
    {
        code: 'begin with',
        eatRegexp: /^begin\s+with/i,
        matchRegexp: /^begin\s+with($|\s+)/i,
        type: 'operator BEGIN-WITH'
    },
    {
        code: 'end with',
        eatRegexp: /^end\s+with/i,
        matchRegexp: /^end\s+with($|\s+)/i,
        type: 'operator END-WITH'
    },
    {
        code: 'include any',
        eatRegexp: /^include\s+any/i,
        matchRegexp: /^include\s+any($|\s+)/i,
        type: 'operator INCLUDE-ANY'
    },
    // {
    //     code: 'include all',
    //     eatRegexp: /^include\s+all/i,
    //     matchRegexp: /^include\s+all($|\s+)/i,
    //     type: 'operator INCLUDE-ALL'
    // },
    // {
    //     code: 'exclude any',
    //     eatRegexp: /^exclude\s+any/i,
    //     matchRegexp: /^exclude\s+any($|\s+)/i,
    //     type: 'operator EXCLUDE-ANY'
    // },
    {
        code: 'exclude all',
        eatRegexp: /^exclude\s+all/i,
        matchRegexp: /^exclude\s+all($|\s+)/i,
        type: 'operator EXCLUDE-ALL'
    },
    {
        code: 'between',
        eatRegexp: /^between/i,
        matchRegexp: /^between($|\s+)/i,
        type: 'operator BETWEEN'
    },
    {
        code: 'and',
        eatRegexp: /^and/i,
        matchRegexp: /^and($|\s+)/i,
        type: 'operator BETWEEN-AND'
    },
    {
        code: 'any >=',
        eatRegexp: /^any\s+\>\=/i,
        matchRegexp: /^any\s+\>\=($|\s+)/i,
        type: 'operator ANY-GTE'
    },
    {
        code: 'any >',
        eatRegexp: /^any\s+\>/i,
        matchRegexp: /^any\s+\>($|\s+)/i,
        type: 'operator ANY-GT'
    },
    {
        code: 'any <=',
        eatRegexp: /^any\s+\<\=/i,
        matchRegexp: /^any\s+\<\=($|\s+)/i,
        type: 'operator ANY-LTE'
    },
    {
        code: 'any <',
        eatRegexp: /^any\s+\</i,
        matchRegexp: /^any\s+\<($|\s+)/i,
        type: 'operator ANY-LT'
    },
    {
        code: 'any ==',
        eatRegexp: /^any\s+\=\=/i,
        matchRegexp: /^any\s+\=\=($|\s+)/i,
        type: 'operator ANY-EQ'
    },
    {
        code: 'any !=',
        eatRegexp: /^any\s+\!\=/i,
        matchRegexp: /^any\s+\!\=($|\s+)/i,
        type: 'operator ANY-NEQ'
    },
    {
        code: 'any between',
        eatRegexp: /^any between/i,
        matchRegexp: /^any between($|\s+)/i,
        type: 'operator ANY-BETWEEN'
    },
    {
        code: 'all >=',
        eatRegexp: /^all\s+\>\=/i,
        matchRegexp: /^all\s+\>\=($|\s+)/i,
        type: 'operator ALL-GTE'
    },
    {
        code: 'all >',
        eatRegexp: /^all\s+\>/i,
        matchRegexp: /^all\s+\>($|\s+)/i,
        type: 'operator ALL-GT'
    },
    {
        code: 'all <=',
        eatRegexp: /^all\s+\<\=/i,
        matchRegexp: /^all\s+\<\=($|\s+)/i,
        type: 'operator ALL-LTE'
    },
    {
        code: 'all <',
        eatRegexp: /^all\s+\</i,
        matchRegexp: /^all\s+\<($|\s+)/i,
        type: 'operator ALL-LT'
    },
    {
        code: 'all ==',
        eatRegexp: /^all\s+\=\=/i,
        matchRegexp: /^all\s+\=\=($|\s+)/i,
        type: 'operator ALL-EQ'
    },
    {
        code: 'all !=',
        eatRegexp: /^all\s+\!\=/i,
        matchRegexp: /^all\s+\!\=($|\s+)/i,
        type: 'operator ALL-NEQ'
    },
    {
        code: 'all between',
        eatRegexp: /^all between/i,
        matchRegexp: /^all between($|\s+)/i,
        type: 'operator ALL-BETWEEN'
    },
    {
        code: 'any contain',
        eatRegexp: /^any\s+contain/i,
        matchRegexp: /^any\s+contain($|\s+)/i,
        type: 'operator ANY-CONTAIN'
    },
    {
        code: 'any not contain',
        eatRegexp: /^any\s+not\s+contain/i,
        matchRegexp: /^any\s+not\s+contain($|\s+)/i,
        type: 'operator ANY-NOT-CONTAIN'
    },
    {
        code: 'any begin with',
        eatRegexp: /^any\s+begin\s+with/i,
        matchRegexp: /^any\s+begin\s+with($|\s+)/i,
        type: 'operator ANY-BEGIN-WITH'
    },
    {
        code: 'any end with',
        eatRegexp: /^any\s+end\s+with/i,
        matchRegexp: /^any\s+end\s+with($|\s+)/i,
        type: 'operator ANY-END-WITH'
    },
    {
        code: 'all contain',
        eatRegexp: /^all\s+contain/i,
        matchRegexp: /^all\s+contain($|\s+)/i,
        type: 'operator ALL-CONTAIN'
    },
    {
        code: 'all not contain',
        eatRegexp: /^all\s+not\s+contain/i,
        matchRegexp: /^all\s+not\s+contain($|\s+)/i,
        type: 'operator ALL-NOT-CONTAIN'
    },
    {
        code: 'all begin with',
        eatRegexp: /^all\s+begin\s+with/i,
        matchRegexp: /^all\s+begin\s+with($|\s+)/i,
        type: 'operator ALL-BEGIN-WITH'
    },
    {
        code: 'all end with',
        eatRegexp: /^all\s+end\s+with/i,
        matchRegexp: /^all\s+end\s+with($|\s+)/i,
        type: 'operator ALL-END-WITH'
    }
];

export const operators = [
    'not contain', 'contain', 'not in', 'in', 'is not null', 'is null',
    'begin with', 'end with',
    'include any',
    // 'include all',
    // 'exclude any',
    'exclude all',
    'between  and',
    'any >', 'any >=', 'any <', 'any <=', 'any ==', 'any !=', 'any between  and',
    'all >', 'all >=', 'all <', 'all <=', 'all ==', 'all !=', 'all between  and',
    'any contain', 'any not contain', 'any begin with', 'any end with',
    'all contain', 'all not contain', 'all begin with', 'all end with',
    'any is not null', 'any is null',
    'all is not null', 'all is null',
];

export const DefaultOperatorReplacements: IOperatorReplacement[] = [
    // { name: '与', code: '&&' },
    // { name: '或', code: '||' },
    // { name: '大于', code: '>' }
];

export const DefaultCustomProperties: ICustomProperty[] = [
    // { id: 123, name: '性别', dataType: 'String', disabled: true },
    // { id: 234, name: '年龄', dataType: 'Integer' },
    // { id: 345, name: '姓名', dataType: 'String' }
    // { id: 123, name: '单排段位', dataType: 'Id', expression: 'CURRENT_MEMBER_GRADE(163)' }
];

export const DefaultPromptMessages: IPromptMessages = {
    invalidCustomProperty: '无效的属性',
    invalidCustomPropertyTooltip: '无效的属性',
    disabledCustomPropertyTooltip: '属性被禁用',

    invalidPointAccount: '无效的积分账户',
    invalidPointAccountTooltip: '无效的积分账户',
    disabledPointAccountTooltip: '积分账户被禁用',

    invalidGradeHierarchy: '无效的等级体系',
    invalidGradeHierarchyTooltip: '无效的等级体系',
    disabledGradeHierarchyTooltip: '等级体系被禁用',
};
